<template>
	<div>
		<br/>
		<div class="row">
			<div class="col-md-4">
				<input type="radio" v-model="type" id="image" name="gender" value="image">&nbsp;&nbsp;&nbsp;&nbsp;
				<label for="image">Image</label><br>
			</div>
			<div class="col-md-4">
				<input type="radio" v-model="type" id="video" name="gender" value="video">&nbsp;&nbsp;&nbsp;&nbsp;
				<label for="video">Video</label><br>
			</div>
		</div>
		<hr/>
		<input class="form-control" v-model="media_url" placeholder="Media URL">
		<button class="btn btn-success">Upload</button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				type: 'image',
				media_url: null
			}
		}
	}
</script>
